<app-base-modal
  [title]="getModalTitle()"
  size="large"
>
  @if (isLoading) {
    <app-loader/>
  }
  @if (isAdvertisementPackage) {
    <app-records-advertisement-packages
      [recordsAdvertisementPackagesParams]="{
        advertisementPackageId: advertisementPackageId,
        recordCalendarId: recordCalendarId
      }"
      (onCloseDialog)="closeDialog($event)"
      (handleDetachData)="handleDetachData($event)"
      (handleSetLoadingState)="handleSetLoadingState($event)"
    />
  } @else {
    <app-new-advertisement-packages
      [recordData]="dialogData.recordData"
      (onCloseDialog)="closeDialog($event)"
      (handleAttachData)="handleAttachData($event)"
   />
  }
</app-base-modal>
